module.exports = __webpack_public_path__ + "img/fscgq.754e9219.png";